import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import { AccessType } from "../../../cbi-generator/generated/dto/AccessType";
import { Scope, ScopeRowId } from "../../../cbi-generator/generated/dto/Scope";

type ReportingAuth = Pick<ReturnType<typeof useAuthStore>, "hasPermission">;

export function hasReportingAccess(
  auth: ReportingAuth,
  access: AccessType.READ | AccessType.WRITE,
) {
  const domain = ScopeRowId[Scope.REPORTING];
  return (
    auth.hasPermission(domain, access) ||
    auth.hasPermission(domain, AccessType.READ_WRITE)
  );
}

export function canAccessReportingRoute(
  reporting: unknown,
  auth: ReportingAuth,
) {
  return reporting !== true || hasReportingAccess(auth, AccessType.READ);
}

export function useReportingPermissions() {
  const auth = useAuthStore();
  const canReadReporting = computed(() =>
    hasReportingAccess(auth, AccessType.READ),
  );
  const canWriteReporting = computed(() =>
    hasReportingAccess(auth, AccessType.WRITE),
  );
  function requireReportingWrite() {
    auth.requireOneOfPermissions([
      { domain: ScopeRowId[Scope.REPORTING], action: AccessType.WRITE },
      {
        domain: ScopeRowId[Scope.REPORTING],
        action: AccessType.READ_WRITE,
      },
    ]);
  }
  return { canReadReporting, canWriteReporting, requireReportingWrite };
}
